import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import Utils from "../../../utils/Utils";
import Loader from "../../../components/Loader";
import WebUtils from "../../../utils/WebUtils";
import { getModuleAccessInfoApi } from "../../../api/candidate";

function CVOptimizer() {
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="cv-optimizer" userRole="candidate" />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="cv-optimizer"
            userRole="candidate"
            newTitle="CV Optimizer"
            noNavigate={true}
          />

          {/* {moduleInfo?.hasMockTestAccess && <div></div>}
          {moduleInfo?.hasMockTestAccess === false && (
            <RequestAccess moduleName="CV_OPTIMIZER" />
          )} */}
          <RequestAccess moduleName="CV_OPTIMIZER" />
        </div>
      </div>
    </>
  );
}

export default CVOptimizer;
